@if (fetchingDataFromServer === true && !offlineMode) {
  <div class="alert alert-primary mb-3">
    <div class="fw-bold">
      Fetching Data from Server
      <div class="spinner-grow float-end" role="status"></div>
    </div>
  </div>
}

@if (runSheetDetailData?.id) {
  <div
    class="d-flex flex-column justify-content-end border shadow p-1 p-lg-3 col-lg-6 col-12 bg-white"
  >
    <div
      class="d-flex flex-wrap column-gap-4 p-2 p-lg-3 justify-content-between"
    >
      <dl id="runSheetName">
        <div class="d-flex align-items-center">
          <div class="flex-grow-1">
            <dt>Patrol Run</dt>
            <dd
              [ngClass]="
                isCurrentORFutureSchedule && (isAdmin || isDispatchUser)
                  ? 'link-edit'
                  : 'text-dark'
              "
              (click)="
                isCurrentORFutureSchedule && (isAdmin || isDispatchUser)
                  ? openTemplate(updateRunSheetName, 'name')
                  : null
              "
            >
              {{ runSheetDetailData?.name }}
            </dd>
          </div>
        </div>
      </dl>
      <div>
        <dl>
          <!-- Date/Duration Section -->
          <dt>Start Date</dt>
          <dd class="text-dark">
            {{
              runSheetDetailData?.schedule_event_date ||
                runSheetDetailData?.roster_scheduler?.start_day
                | customDate: "d MMM y"
            }}
          </dd>
        </dl>
      </div>
      <div>
        <dl>
          <div class="d-flex align-items-center">
            <div class="flex-grow-1">
              <dt>Schedule</dt>
              <dd
                [class.link-edit]="
                  isCurrentORFutureSchedule && (isAdmin || isDispatchUser)
                "
                (click)="
                  isCurrentORFutureSchedule && (isAdmin || isDispatchUser)
                    ? openScheduleTemplate()
                    : null
                "
              >
                {{ runSheetDetailData?.roster_scheduler?.start_time }} -
                <span>{{ endDateTime | customDate: "d MMM y" }}</span>
                {{ runSheetDetailData?.roster_scheduler?.end_time }}
              </dd>
            </div>
          </div>
        </dl>
      </div>
      <div>
        <dl>
          <div class="d-flex align-items-center">
            <div class="flex-grow-1">
              <dt>Duration</dt>
              <dd>
                {{
                  runSheetDetailData?.roster_scheduler
                    | misc: "getTimeDifference"
                }}
              </dd>
            </div>
          </div>
        </dl>
      </div>
      @if (isAdmin || isDispatchUser) {
        <div>
          <dl>
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <dt>Assigned</dt>
                <dd
                  [class.link-edit]="
                    isCurrentORFutureSchedule && (isAdmin || isDispatchUser)
                  "
                  (click)="
                    isCurrentORFutureSchedule && (isAdmin || isDispatchUser)
                      ? openTemplate(
                          singleAssigneeSelectionTemplate,
                          'assignee'
                        )
                      : null
                  "
                >
                  @if (runSheetDetailData?.assignee?.id) {
                    {{ runSheetDetailData?.assignee?.full_name }}
                  } @else {
                    <div class="text-danger">Not Assigned</div>
                  }
                </dd>
              </div>
            </div>
          </dl>
        </div>
      }
    </div>

    @if (
      shiftClockInOutParms.requiresClockInOut &&
      !shiftClockInOutParms.hasUserClockedOut
    ) {
      <div class="col mb-2">
        @if (shiftClockInOutParms.hasUserClockedIn) {
          <button
            class="btn btn-md w-100 btn-warning"
            (click)="onClockInOutUser()"
          >
            Clock Out
          </button>
        } @else {
          <button
            class="btn btn-md w-100 btn-primary"
            [disabled]="startsAfterToday"
            (click)="onClockInOutUser()"
          >
            Clock In
          </button>
        }
      </div>
    }
    @if (shiftClockInOutParms.hasUserClockedOut) {
      <div class="alert alert-info text-center fw-semibold small">
        You have already clocked out of this shift.
      </div>
    }
    @if (showTasksMenu) {
      <ng-container>
        <div>
          <dl id="checkList" class="mb-0">
            <dd>
              @if (isCurrentORFutureSchedule) {
                <ul class="nav nav-tabs border-0" id="myTab" role="tablist">
                  @if (
                    runSheetDetailData?.check_list_data?.pending_tasks?.length
                  ) {
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link"
                        [class.active]="activeTab === 'pending'"
                        (click)="
                          setActiveTab('pending');
                          filteredSiteList = [];
                          strSearchSite = ''
                        "
                        id="pending-tab"
                        type="button"
                        role="tab"
                        aria-controls="pending"
                        [attr.aria-selected]="activeTab === 'pending'"
                      >
                        Pending
                      </button>
                    </li>
                  }
                  @if (
                    runSheetDetailData?.check_list_data?.completed_tasks?.length
                  ) {
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link"
                        [class.active-completed-tab]="activeTab === 'completed'"
                        (click)="
                          setActiveTab('completed');
                          filteredSiteList = [];
                          strSearchSite = ''
                        "
                        id="completed-tab"
                        type="button"
                        role="tab"
                        aria-controls="completed"
                        [attr.aria-selected]="activeTab === 'completed'"
                      >
                        {{
                          activeTab === "completed"
                            ? "Showing Completed Jobs"
                            : "Completed Jobs"
                        }}
                      </button>
                    </li>
                  }
                </ul>
                <div class="tab-content" id="myTabContent">
                  <div
                    class="tab-pane fade"
                    [class.show]="activeTab === 'pending'"
                    [class.active]="activeTab === 'pending'"
                    id="pending"
                    role="tabpanel"
                    aria-labelledby="pending-tab"
                  >
                    <div class="my-2">
                      <gtapp-auto-complete
                        [data]="filteredSiteList"
                        placeHolder="Search Sites"
                        searchKeyword="company_name"
                        [itemTemplate]="siteLookupTemplate2"
                        (inputFocused)="
                          getfilteredSiteListData(
                            runSheetDetailData?.check_list_data?.pending_tasks
                          )
                        "
                        (inputChanged)="
                          getfilteredSiteListData(
                            runSheetDetailData?.check_list_data?.pending_tasks,
                            $event
                          )
                        "
                        (selected)="scrollToSelectedSite($event)"
                        [enableCloseOption]="true"
                      >
                      </gtapp-auto-complete>
                    </div>
                    <ng-template #siteLookupTemplate2 let-item>
                      <div class="d-flex gap-2 align-items-center">
                        <div>
                          <div class="fw-medium">
                            {{ item?.company_name }} [{{
                              item?.company?.company_name
                            }}]
                          </div>
                          @if (item?.taskCount) {
                            <div>
                              Tasks Remaining:
                              <span class="fw-semibold">
                                {{ item?.taskCount }}</span
                              >
                            </div>
                          }
                          <div class="small-font text-secondary">
                            {{
                              item?.address?.full_address || item?.full_address
                            }}
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <div class="overflow-60vh">
                      @for (
                        item of runSheetDetailData?.check_list_data
                          ?.pending_tasks;
                        track item;
                        let i = $index
                      ) {
                        <div>
                          <ng-template
                            *ngTemplateOutlet="
                              selectedCheckListTemplate;
                              context: { value: item, index: i }
                            "
                          ></ng-template>
                        </div>
                      }
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    [class.show]="activeTab === 'completed'"
                    [class.active]="activeTab === 'completed'"
                    id="completed"
                    role="tabpanel"
                    aria-labelledby="completed-tab"
                  >
                    <div class="my-2">
                      <gtapp-auto-complete
                        [data]="filteredSiteList"
                        placeHolder="Search Sites"
                        searchKeyword="company_name"
                        [itemTemplate]="siteTemplate"
                        (inputFocused)="
                          getfilteredSiteListData(
                            runSheetDetailData?.check_list_data?.completed_tasks
                          )
                        "
                        (inputChanged)="
                          getfilteredSiteListData(
                            runSheetDetailData?.check_list_data
                              ?.completed_tasks,
                            $event
                          )
                        "
                        (selected)="scrollToSelectedSite($event)"
                        [enableCloseOption]="true"
                      >
                      </gtapp-auto-complete>
                    </div>
                    <ng-template #siteTemplate let-item>
                      <div class="d-flex gap-2 align-items-center">
                        <div>
                          <div class="fw-medium">
                            {{ item?.company_name }} [{{
                              item?.company?.company_name
                            }}]
                          </div>
                          @if (item?.taskCount) {
                            <div>
                              Tasks Remaining:
                              <span class="fw-semibold">
                                {{ item?.taskCount }}</span
                              >
                            </div>
                          }
                          <div class="small-font text-secondary">
                            {{
                              item?.address?.full_address || item?.full_address
                            }}
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <div class="overflow-60vh">
                      @for (
                        item of runSheetDetailData?.check_list_data
                          ?.completed_tasks;
                        track item;
                        let i = $index
                      ) {
                        <div>
                          <ng-template
                            *ngTemplateOutlet="
                              selectedCheckListTemplate;
                              context: {
                                value: item,
                                index: i,
                                completed: true,
                              }
                            "
                          ></ng-template>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              } @else {
                <div class="my-2">
                  <gtapp-auto-complete
                    [data]="filteredSiteList"
                    placeHolder="Search Sites"
                    searchKeyword="company_name"
                    [itemTemplate]="siteLookupTemplate1"
                    (inputFocused)="
                      getfilteredSiteListData(
                        runSheetDetailData?.check_list_data?.pending_tasks?.concat(
                          runSheetDetailData?.check_list_data?.completed_tasks
                        )
                      )
                    "
                    (inputChanged)="
                      getfilteredSiteListData(
                        runSheetDetailData?.check_list_data?.pending_tasks?.concat(
                          runSheetDetailData?.check_list_data?.completed_tasks
                        ),
                        $event
                      )
                    "
                    (selected)="scrollToSelectedSite($event)"
                    [enableCloseOption]="true"
                  >
                  </gtapp-auto-complete>
                </div>
                <ng-template #siteLookupTemplate1 let-item>
                  <div class="d-flex gap-2 align-items-center">
                    <div>
                      <div class="fw-medium">
                        {{ item?.company_name }} [{{
                          item?.company?.company_name
                        }}]
                      </div>
                      @if (item?.taskCount) {
                        <div>
                          Tasks Remaining:
                          <span class="fw-semibold">
                            {{ item?.taskCount }}</span
                          >
                        </div>
                      }
                      <div class="small-font text-secondary">
                        {{ item?.address?.full_address || item?.full_address }}
                      </div>
                    </div>
                  </div>
                </ng-template>
                <div class="overflow-60vh">
                  @for (
                    item of runSheetDetailData?.check_list_data?.pending_tasks?.concat(
                      runSheetDetailData?.check_list_data?.completed_tasks
                    );
                    track item;
                    let i = $index
                  ) {
                    <div>
                      <ng-template
                        *ngTemplateOutlet="
                          selectedCheckListTemplate;
                          context: { value: item, index: i }
                        "
                      ></ng-template>
                    </div>
                  }
                </div>
              }
            </dd>
          </dl>
        </div>
        @if ((isAdmin || isDispatchUser) && isCurrentORFutureSchedule) {
          <div id="addTask" class="p-2 p-lg-3 border-0 mb-3 mb-lg-1">
            <div
              role="button"
              class="rounded border bg-secondary-subtle p-2 ps-3 mb-1 text-center hover text-dark"
              (click)="
                (isAdmin || isDispatchUser) && isCurrentORFutureSchedule
                  ? openTemplate(addMoreCheckListTemplate, 'checklist')
                  : ''
              "
            >
              Add Patrol
            </div>
          </div>
        }
      </ng-container>
    }
  </div>
}

<ng-template
  #selectedCheckListTemplate
  let-item="value"
  let-index="index"
  let-completedTab="completed"
>
  <div class="p-2 p-lg-3 border mb-2">
    <ng-container>
      @if (item?.site_data?.id) {
        <div [id]="item?.site_data?.id">
          <div class="d-flex gap-2">
            <div class="flex-grow-1">
              <div class="mb-2 me-4">
                <div
                  [class.link-view]="
                    !offlineMode && (isAdmin || isDispatchUser)
                  "
                  (click)="
                    !offlineMode && (isAdmin || isDispatchUser)
                      ? redirectToSite(item?.site_data?.id)
                      : null
                  "
                >
                  <span class="me-2 fw-normal">{{ index + 1 }}.</span>
                  <span class="fw-semibold">{{
                    item?.site_data?.company_name
                  }}</span>
                  [{{ item?.site_data?.company?.company_name }}]
                </div>

                <div class="small text-secondary fw-normal">
                  {{ item?.site_data?.full_address }}
                </div>
              </div>
            </div>

            @if (
              (isAdmin || isDispatchUser) &&
              (item?.check_list_schedule_uuid || item?.check_list_uuid) &&
              startsAfterToday &&
              runSheetDetailData?.check_list_data?.pending_tasks?.length > 1
            ) {
              <div
                [ngClass]="!largeView ? 'p-2 fs-2 pe-0' : ''"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Delete Site"
                (click)="
                  openTemplate(
                    deleteCheckListTemplate,
                    'delete_checklist',
                    item
                  )
                "
              >
                <i class="fa-solid fa-minus-circle text-danger fs-3"></i>
              </div>
            }
            @if (item?.job_data?.id) {
              <div
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Open Docket"
                class="text-primary"
                [ngClass]="!largeView ? 'p-2 fs-2' : ''"
                (click)="redirectToJob(item?.job_data)"
              >
                <i class="fa-solid fa-file-invoice fs-3"></i>
              </div>
            }
            @if (
              !completedTab &&
              !item?.job_data?.id &&
              item?.check_list_uuid &&
              (isAdmin || isDispatchUser)
            ) {
              <div
                [ngClass]="!largeView ? 'p-2 fs-2' : ''"
                class="text-primary opacity-50"
                (click)="
                  enableReporting({
                    job_data: {
                      company_id: item?.site_data?.company?.id,
                      job_type_id: runSheetJobType?.id,
                      site_id: item?.site_data?.id,
                      check_list_uuid: item?.check_list_uuid,
                    },
                  })
                "
              >
                <i class="fa-solid fa-file-invoice fs-3"></i>
              </div>
            }
          </div>
        </div>
      } @else {
        <div class="d-flex gap-2">
          <span>{{ index + 1 }}.</span>
          <div class="fw-semibold text-secondary">Tasks w/o Site</div>
        </div>
      }
      @if (
        (item?.tasks?.length ||
          (item?.job_data?.id && (isAdmin || isDispatchUser))) &&
        openIndex != index
      ) {
        <div class="text-center mt-3">
          <button
            class="btn btn-sm btn-outline-secondary"
            (click)="onOpenIndex(index)"
          >
            See Details
          </button>
        </div>
      }
    </ng-container>
    @if (openIndex == index) {
      @if (
        item?.cp_exists &&
        item?.job_data?.id &&
        activeTab == "pending" &&
        (isAdmin || isDispatchUser)
      ) {
        <div class="mb-3">
          <button
            (click)="onAddCheckpointsToRoute(item)"
            class="btn"
            [ngClass]="
              item?.selectedCheckpoints?.length
                ? 'btn-primary'
                : 'btn-outline-primary'
            "
          >
            {{
              item?.selectedCheckpoints?.length
                ? "Edit Checkpoints"
                : "Include Checkpoint Scans"
            }}
          </button>
        </div>
      }
      @if (item?.site_data?.id) {
        <div>
          <!--site information-->
          @if (item?.site_data?.site_information) {
            <dd class="gt-multi-line text-dark mb-2">
              {{ item?.site_data?.site_information }}
            </dd>
          }
          <gtapp-site-keys
            [selectedSite]="item?.site_data"
            [showManageOption]="false"
          ></gtapp-site-keys>
        </div>
      }

      @if (item?.tasks?.length > 0) {
        <dt class="pt-3 pb-2">Tasks</dt>
      }

      @for (task of item?.tasks; track task; let subIndex = $index) {
        @let completedTaskInfo = completedCheckListData?.[task?.id];
        <div class="rounded border bg-secondary-subtle p-2 ps-3 mb-1 pb-1">
          <div class="d-flex gap-2 align-items-center">
            @if (!startsAfterToday && isCurrentORFutureSchedule) {
              @if (
                item?.site_data?.id &&
                item?.job_data?.id &&
                (!item?.job_data?.status_identity ||
                  [4, 5].includes(item?.job_data?.status_identity))
              ) {
                <input
                  [checked]="completedTaskInfo"
                  type="checkbox"
                  [disabled]="completedTaskInfo"
                  readonly
                  (click)="
                    redirectToJob(item?.job_data); $event.preventDefault()
                  "
                />
              } @else {
                <input
                  [disabled]="completedTaskInfo"
                  [checked]="completedTaskInfo"
                  type="checkbox"
                  readonly
                  (click)="
                    openCheckListMarkCompleteTemplate(
                      checkListCompleteTemplateRef,
                      task
                    );
                    $event.preventDefault()
                  "
                />
              }
            }
            @if (task?.prompt?.id) {
              <span>
                <i class="fa-solid fa-clipboard-list text-success"></i
              ></span>
            }
            <div
              class="gt-multi-line text-dark me-4 flex-grow-1"
              [class.text-decoration-line-through]="completedTaskInfo"
              [class.link-edit]="
                !completedTaskInfo &&
                !task?.prompt?.id &&
                (isAdmin || isDispatchUser) &&
                isCurrentORFutureSchedule
              "
              (click)="
                !completedTaskInfo &&
                !task?.prompt?.id &&
                (isAdmin || isDispatchUser) &&
                isCurrentORFutureSchedule
                  ? editCheckListTextTemplate(
                      updateCheckListItemTemplate,
                      task,
                      item
                    )
                  : null
              "
            >
              {{ task?.note }}
            </div>

            @if (completedTaskInfo?.prompts?.length) {
              <button
                class="btn btn-outline-secondary btn-sm"
                (click)="
                  openTemplate(
                    promptTemplate,
                    'prompts',
                    completedTaskInfo?.prompts
                  )
                "
              >
                Details
              </button>
            }

            @if (!isCurrentORFutureSchedule) {
              @if (!completedTaskInfo) {
                <div class="small text-danger fw-bold">[Missed]</div>
              }
            } @else {
              <div>
                <div class="d-flex gap-2 justify-content-end">
                  <!-- @if (
                    !completedTaskInfo && !startsAfterToday
                  ) {
                    @if (
                      item?.site_data?.id &&
                      item?.job_data?.id &&
                      (!item?.job_data?.status_identity ||
                        [4, 5].includes(item?.job_data?.status_identity))
                    ) {
                      <div>
                        <button
                          class="btn btn-success"
                          (click)="redirectToJob(item?.job_data)"
                        ></button>
                      </div>
                    } @else {
                      <button
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Mark Completed"
                        class="btn btn-success"
                        (click)="
                          openCheckListMarkCompleteTemplate(
                            checkListCompleteTemplateRef,
                            task
                          )
                        "
                      >
                        <input type="checkbox" />
                      </button>
                    }
                  } -->
                  @if (
                    (isAdmin || isDispatchUser) && isCurrentORFutureSchedule
                  ) {
                    <div>
                      <button
                        class="btn"
                        [ngClass]="
                          task?.schedule?.reminder
                            ? 'btn-primary'
                            : 'btn-outline-secondary opacity-50'
                        "
                        (click)="
                          !completedTaskInfo &&
                          (isAdmin || isDispatchUser) &&
                          isCurrentORFutureSchedule
                            ? editCheckListTextTemplate(
                                updateCheckListItemTemplate,
                                task,
                                item,
                                true
                              )
                            : null
                        "
                      >
                        <i
                          class="fa-solid fa-bell"
                          [ngClass]="
                            task?.schedule?.reminder ? '' : 'text-secondary'
                          "
                        ></i>
                      </button>
                    </div>
                  }
                  @if (isAdmin || isDispatchUser) {
                    <div>
                      <button
                        class="btn btn-outline-danger"
                        (click)="deleteCheckListTask(task)"
                      >
                        <i class="fa-solid fa-trash"></i>
                      </button>
                    </div>
                  }
                </div>
                <div class="small mt-1 text-center">
                  @if (task?.schedule?.reminder && !completedTaskInfo) {
                    <span class="text-secondary">Reminder: </span>
                    <span class="fw-semibold">
                      @if (task?.schedule?.start_datetime) {
                        {{ task?.schedule | misc: "runsheetTaskTiming" }}
                      } @else if (task?.schedule?.start_time) {
                        {{ task?.schedule?.start_time }}
                      }
                    </span>
                  }
                </div>
              </div>
            }
          </div>
          @if (completedTaskInfo) {
            <div class="text-end pb-1">
              @if (completedTaskInfo?.cachedData) {
                <div class="ms-1">
                  @if (
                    errorItemsIdsInQueue.has(completedTaskInfo?.index_db_id)
                  ) {
                    <span
                      (click)="retrySendingUpdate()"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="An error occured while saving data. Retrying."
                    >
                      <i
                        class="fa-solid fa-triangle-exclamation text-danger md-font-size"
                      ></i>
                    </span>
                  } @else {
                    <span
                      (click)="retrySendingUpdate()"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="This update has not yet been uploaded to the server."
                    >
                      <i
                        class="fa-solid fa-triangle-exclamation text-warning md-font-size"
                      ></i>
                    </span>
                  }
                </div>
              }
              <div class="text-secondary small-font">
                {{
                  completedTaskInfo?.updated_datetime
                    | customDate: "d MMM y HH:mm"
                }}

                | {{ completedTaskInfo?.user_name }}
              </div>
              {{ completedTaskInfo?.detail }}
            </div>
          }
        </div>
      }
      @if ((isAdmin || isDispatchUser) && isCurrentORFutureSchedule) {
        <div
          role="button"
          data-bs-toggle="tooltip"
          data-bs-placement="bottom"
          title="Add Task"
          class="rounded border bg-secondary-subtle p-2 ps-3 mb-1 text-center hover fw-normal"
          (click)="
            (isAdmin || isDispatchUser) && isCurrentORFutureSchedule
              ? openTemplate(addMoreTaskTemplate, 'checklist_tasks', item)
              : ''
          "
        >
          Add Task
        </div>
      }
    }
  </div>
</ng-template>

<ng-template
  #singleAssigneeSelectionTemplate
  let-data
  let-singleAssigneeSelectionTemplate="dialogRef"
>
  <div class="card dialog-box">
    <div class="card-header">
      <span class="float-end" (click)="singleAssigneeSelectionTemplate.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <div class="p-3">
        @if (selectedAssignee?.id) {
          <dl>
            <dt class="text-body">Assigned To</dt>
            <dd
              class="link-edit text-body"
              (click)="
                selectedAssignee = {};
                clearAndFocusTextBox('assigneLookupFieldId')
              "
            >
              <span> {{ selectedAssignee?.full_name }}</span>
            </dd>
          </dl>
        } @else {
          <gtapp-auto-complete
            [data]="assigneeList"
            placeHolder="Search/Select Assignee"
            searchKeyword="full_name"
            inputId="assigneLookupFieldId"
            [initialValue]="selectedAssignee?.full_name"
            [itemTemplate]="assigneeLookupTemplate"
            (inputChanged)="onAssigneeSearch($event)"
            (selected)="selectedAssignee = $event"
            [enableCloseOption]="true"
          >
          </gtapp-auto-complete>

          <ng-template #assigneeLookupTemplate let-item>
            <div class="d-flex gap-2 flex-wrap">
              <span>
                {{ item?.full_name }}
              </span>
              @if (item?.access_status === 2) {
                <div
                  class="text-warning-emphasis small-font bg-white rounded my-auto border px-2 fw-semibold"
                >
                  Casual
                </div>
              }
            </div>

            @if (item?.subcontractors?.length) {
              <div class="small text-secondary">
                🟧Subcontractor:
                <span class="subcontractor-name">{{
                  item?.subcontractors
                }}</span>
              </div>
            }
          </ng-template>
        }
      </div>
      @if (runSheetDetailData?.future_schedule_exists) {
        <div
          class="col col-6 offset-6 my-3 gap-2 d-flex align-items-center justify-content-center fw-semibold"
        >
          <input
            class="form-check-input"
            type="checkbox"
            id="auto_send_reports"
            [checked]="runSheetDetailData?.current_shift_only"
            (change)="
              runSheetDetailData.current_shift_only =
                !runSheetDetailData?.current_shift_only
            "
          />
          <label class="form-check-label" for="auto_send_reports">
            Apply only to this shift</label
          >
        </div>
      }

      <div class="row row-cols-2 mt-4">
        <div class="col">
          <button
            class="btn btn-lg w-100 btn-dark"
            (click)="singleAssigneeSelectionTemplate.close()"
          >
            Cancel
          </button>
        </div>

        <div class="col">
          <button
            class="btn btn-primary btn-lg w-100"
            [disabled]="
              !selectedAssignee?.id ||
              selectedAssignee?.id === runSheetDetailData?.assignee?.id ||
              updateBtnPressed
            "
            (click)="
              updateRunSheet(
                'assignee',
                {},
                {
                  add_to_schedule: runSheetDetailData?.current_shift_only
                    ? 0
                    : runSheetDetailData?.future_schedule_exists
                      ? 1
                      : 0,
                }
              )
            "
          >
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #updateRunSheetName let-updateRunSheetName="dialogRef">
  <div class="dialog-box card">
    <div class="card-header">
      <span class="float-end" (click)="updateRunSheetName.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="form-floating mt-3">
      <input
        class="form-control"
        id="mobassigneeField"
        [(ngModel)]="newRunSheetName"
        type="text"
        autocomplete="off"
        placeholder="Patrol Run Name"
      />
      <label>Patrol Run Name</label>
    </div>
    @if (runSheetDetailData?.future_schedule_exists) {
      <div
        class="col col-6 offset-6 my-3 gap-2 d-flex align-items-center justify-content-center fw-semibold"
      >
        <input
          class="form-check-input"
          type="checkbox"
          id="auto_send_reports"
          [checked]="runSheetDetailData?.current_shift_only"
          (change)="
            runSheetDetailData.current_shift_only =
              !runSheetDetailData?.current_shift_only
          "
        />
        <label class="form-check-label" for="auto_send_reports">
          Apply only to this shift</label
        >
      </div>
    }
    <div class="row row-cols-2 mt-4">
      <div class="col">
        <button
          class="btn btn-lg w-100 btn-dark"
          (click)="updateRunSheetName.close()"
        >
          Cancel
        </button>
      </div>

      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          [disabled]="
            newRunSheetName === runSheetDetailData?.name ||
            !newRunSheetName ||
            updateBtnPressed
          "
          (click)="
            updateRunSheet(
              'name',
              {},
              {
                add_to_schedule: runSheetDetailData?.current_shift_only
                  ? 0
                  : runSheetDetailData?.future_schedule_exists
                    ? 1
                    : 0,
              }
            )
          "
        >
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template
  #checkListCompleteTemplateRef
  let-checkListCompleteTemplateRef="dialogRef"
  let-data
>
  <div class="card dialog-box">
    <div class="card-header">
      <span
        class="float-end"
        (click)="checkListCompleteTemplateRef.close(false)"
      >
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <ng-container>
        <div
          class="border bg-secondary-subtle text-dark p-2 mb-2 gt-multi-line"
        >
          {{ data?.note }}
        </div>
      </ng-container>

      <div class="form-group input-group">
        <textarea
          class="form-control"
          rows="1"
          wrap="hard"
          placeholder="Optional Comments"
          autofocus
          [(ngModel)]="data.newComment"
          id="updateCommentBox"
        ></textarea>
        @if (data?.newComment) {
          <span
            class="input-group-text"
            (click)="
              clearAndFocusTextBox('updateCommentBox'); data.newComment = ''
            "
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        }
      </div>
      <div class="row row-cols-2 mt-3">
        <div class="col">
          <button
            type="button"
            class="btn btn-dark btn-lg w-100"
            (click)="checkListCompleteTemplateRef.close(false)"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          <button
            class="btn btn-success btn-lg w-100"
            [disabled]=""
            (click)="checkListCompleteTemplateRef.close(data)"
          >
            Mark Complete
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template
  #updateCheckListItemTemplate
  let-updateCheckListNote="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Update Task

      <span class="float-end" (click)="updateCheckListNote.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    @if (data?.schedule?.editSchedule) {
      @if (data?.task?.note) {
        <div
          class="border bg-secondary-subtle text-dark p-2 mb-2 gt-multi-line"
        >
          {{ data?.task?.note }}
        </div>
      }

      <div class="row row-cols-2 mb-4">
        @if (data?.schedule?.showItems.startEndDateTime) {
          <div class="form-floating">
            <input
              id="startDay"
              class="form-control"
              type="datetime-local"
              placeholder="Pick Reminder Date & Time*"
              [(ngModel)]="data.schedule.start_datetime"
              [min]="data?.schedule?.minDateTime"
              [max]="data?.schedule?.maxDateTime"
              (change)="
                changeStartEndDateTime(
                  $event,
                  data?.schedule,
                  'start_datetime',
                  'startDateTime'
                )
              "
              [class.is-invalid]="data?.schedule?.invalid?.startDateTime"
            /><label for="startDay"> Reminder Date & Time*</label>
          </div>
        }
        @if (data?.schedule?.showItems.startEndTime) {
          <div class="form-floating">
            <input
              type="time"
              class="form-control"
              id="startTime"
              placeholder="Reminder Time*"
              [(ngModel)]="data.schedule.start_time"
              (change)="
                changeStartEndDateTime(
                  $event,
                  data?.schedule,
                  'start_time',
                  'startTime'
                )
              "
              [class.is-invalid]="data?.schedule?.invalid?.startTime"
            />
            <label for="startTime" class="form-label">Reminder Time*</label>
          </div>
        }

        <div class="small-font text-secondary col-12">
          * Reminders can only be set at quarter hour marks
        </div>
      </div>
      <div
        class="row"
        [ngClass]="data?.schedule?.reminder ? 'row-cols-3' : 'row-cols-2'"
      >
        <div class="col">
          <button
            class="btn btn-lg w-100 btn-dark"
            (click)="updateCheckListNote.close()"
          >
            Cancel
          </button>
        </div>
        @if (data?.schedule?.reminder) {
          <div>
            <button
              class="btn btn-lg w-100 btn-danger"
              (click)="
                updateRunSheet('checkListTaskReminder', {
                  check_list_id: data?.task?.id,
                  schedule: {},
                })
              "
            >
              Remove Reminder
            </button>
          </div>
        }

        <div class="col">
          <button
            class="btn btn-primary btn-lg w-100"
            [disabled]="
              (selectedCheckListTask?.schedule?.reminder
                ? selectedCheckListTask?.schedule?.start_datetime ==
                    data?.schedule?.start_datetime &&
                  selectedCheckListTask?.schedule?.end_datetime ==
                    data?.schedule?.end_datetime
                : false) ||
              data?.schedule?.invalid?.startTime ||
              data?.schedule?.invalid?.startDateTime
            "
            (click)="
              updateRunSheet('checkListTaskReminder', {
                check_list_id: data?.task?.id,
                schedule: data?.schedule,
              })
            "
          >
            Update
          </button>
        </div>
      </div>
    } @else {
      <ng-container>
        @if (data?.site_data?.id) {
          <div class="mb-2 p-1">
            <div class="fw-semibold">
              {{ data?.site_data?.company_name }}
              <span class="fw-normal"
                >[{{ data?.site_data?.company?.company_name }}]</span
              >
            </div>
            <div class="small-font text-secondary mb-2">
              {{
                data?.site_data?.address?.full_address ||
                  data?.site_data?.full_address
              }}
            </div>
          </div>
        } @else {
          <div class="mb-1 p-1">
            <div class="fw-semibold text-secondary">Tasks w/o Site</div>
          </div>
        }
      </ng-container>
      <div class="mb-4">
        <textarea
          class="form-control"
          type="text"
          placeholder="Task"
          [(ngModel)]="data.task.note"
          [ngStyle]="data?.task?.ngStyle"
          (input)="onInputTaskNote($event, data)"
          rows="3"
        ></textarea>
      </div>

      <div class="row row-cols-2 mb-2">
        <div class="col mb-2">
          <button
            class="btn btn-md w-100 btn-danger"
            (click)="deleteCheckListTask(data?.task)"
          >
            Remove Task
          </button>
        </div>
        <div class="col mb-2">
          <button
            class="btn btn-md w-100 btn-success"
            (click)="
              openCheckListMarkCompleteTemplate(
                checkListCompleteTemplateRef,
                data?.task
              )
            "
          >
            Mark Complete
          </button>
        </div>

        <div class="col">
          <button
            class="btn btn-lg w-100 btn-dark"
            (click)="updateCheckListNote.close()"
          >
            Cancel
          </button>
        </div>

        <div class="col">
          <button
            class="btn btn-primary btn-lg w-100"
            [disabled]="
              (selectedCheckListTask?.site_data?.id === data?.site_data?.id &&
                selectedCheckListTask?.task?.note === data?.task?.note) ||
              !data?.task?.note
            "
            (click)="
              updateRunSheet('checkListTask', {
                check_list_id: data?.task?.id,
                notes: data?.task?.note,
                site_id: data?.site_data?.id,
              })
            "
          >
            Update
          </button>
        </div>
      </div>
    }
  </div>
</ng-template>
<ng-template #addMoreTaskTemplate let-addMoreTaskTemplateRef="dialogRef">
  <div class="dialog-box card">
    <div class="card-header">
      Add Tasks

      <span class="float-end" (click)="addMoreTaskTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <ng-container>
      @if (selectedCheckList?.site_data?.id) {
        <div class="mb-2 p-1">
          <div class="fw-semibold">
            {{ selectedCheckList?.site_data?.company_name }}
            <span class="fw-normal"
              >[{{ selectedCheckList?.site_data?.company?.company_name }}]</span
            >
          </div>
          <div class="small-font text-secondary mb-2">
            {{
              selectedCheckList?.site_data?.address?.full_address ||
                selectedCheckList?.site_data?.full_address
            }}
          </div>
        </div>
      } @else {
        <div class="mb-1 p-1">
          <div class="fw-semibold text-secondary">Tasks w/o Site</div>
        </div>
      }
    </ng-container>
    <div class="overflow-45vh">
      @for (
        task of selectedCheckList?.tasks;
        track task;
        let subIndex = $index
      ) {
        <div class="mb-2">
          <div class="d-flex align-items-center">
            <div class="flex-grow-1">
              @if (task?.user_prompt_id) {
                <div
                  class="p-2 border rounded bg-secondary-subtle d-flex align-items-center gap-3"
                >
                  <i class="fa-solid fa-clipboard-list text-success"></i>
                  <div class="fw-semibold text-dark">
                    {{ task.note }}
                  </div>
                </div>
              } @else {
                <textarea
                  class="form-control"
                  type="text"
                  [readOnly]="task?.id"
                  [disabled]="task?.id"
                  placeholder="+ Task"
                  [ngStyle]="task?.ngStyle"
                  [(ngModel)]="task.note"
                  (input)="
                    onInputTaskNote($event, task, selectedCheckList?.tasks)
                  "
                  rows="2"
                ></textarea>
              }
            </div>
            @if (task?.note) {
              <div class="d-flex gap-3 ps-3 flex-row">
                @if (selectedCheckList?.tasks?.length > 1 && !task?.id) {
                  <span (click)="selectedCheckList?.tasks?.splice(subIndex, 1)">
                    <i class="fa fa-close text-secondary fs-4"></i>
                  </span>
                }
                <span
                  (click)="duplicateTask(selectedCheckList?.tasks, subIndex)"
                >
                  <i class="fa-regular fa-copy text-secondary fs-4"></i>
                </span>
                @if (!task?.id) {
                  <span
                    (click)="openTaskConfigTemplate(task, taskReminderTemplate)"
                  >
                    @if (!task?.schedule) {
                      <span>
                        <i class="fa-solid fa-bell fa-2x text-secondary"></i>
                      </span>
                    }
                  </span>
                }
              </div>
            }
          </div>
          @if (task?.schedule) {
            <div class="p-2 rounded d-flex align-items-center text-dark mb-3">
              <div class="flex-grow-1">
                @if (task?.schedule?.repeat_details?.length) {
                  <span class="text-secondary"> Task Limited To: </span>
                  {{ task?.schedule?.repeat_details }}
                }
                @if (task?.schedule?.reminder) {
                  <span class="text-secondary"> Reminder Set:</span>
                  @if (task?.schedule?.start_datetime) {
                    {{ task?.schedule | misc: "runsheetTaskTiming" }}
                  } @else if (task?.schedule?.start_time) {
                    {{ task?.schedule?.start_time }}
                  }
                }
              </div>
              <div class="d-flex gap-2">
                <span
                  (click)="openTaskConfigTemplate(task, taskReminderTemplate)"
                >
                  <i class="fa-solid fa-pen-to-square text-secondary fs-4"></i>
                </span>
                <span (click)="task.schedule = null">
                  <i class="fa fa-trash text-secondary fs-4"></i>
                </span>
              </div>
            </div>
          }
        </div>
      }

      @if (userPromptTotalCount > 0) {
        <div class="p-3">
          <dt>Mobile Forms</dt>
          @if (userPromptTotalCount > 3) {
            <div>
              <gtapp-auto-complete
                [data]="userPromptsSearchResults"
                inputId="promptSelectId"
                placeHolder="Search Mobile Forms"
                searchKeyword="name"
                [itemTemplate]="promptLookupTemplate"
                (inputChanged)="searchPrompts($event)"
                (selected)="addPromptTask($event, selectedCheckList)"
              >
              </gtapp-auto-complete>
            </div>
            <ng-template #promptLookupTemplate let-item>
              <div class="fw-bold">
                {{ item?.name }}
              </div>
            </ng-template>
          }

          <div class="d-flex gap-2 my-2 flex-wrap">
            @for (prompt of userPromptsSearchResultsCopy; track prompt?.id) {
              <div
                role="button"
                (click)="addPromptTask(prompt, selectedCheckList)"
                class="p-2 border rounded bg-secondary-subtle d-flex align-items-center justify-content-between gap-3 hover"
              >
                <i class="fa-solid fa-clipboard-list text-success"></i>
                <div class="fw-semibold small text-dark">
                  {{ prompt?.name }}
                </div>
              </div>
            }
          </div>
        </div>
      }
      @if (
        runSheetDetailData?.future_schedule_exists &&
        selectedCheckList?.check_list_schedule_uuid
      ) {
        <div
          class="col col-6 offset-6 my-3 gap-2 d-flex align-items-center justify-content-center fw-semibold"
        >
          <input
            class="form-check-input"
            type="checkbox"
            id="auto_send_reports"
            [checked]="runSheetDetailData?.current_shift_only"
            (change)="
              runSheetDetailData.current_shift_only =
                !runSheetDetailData?.current_shift_only
            "
          />
          <label class="form-check-label" for="auto_send_reports">
            Apply only to this shift</label
          >
        </div>
      }
    </div>
    <div class="row row-cols-2 mt-4">
      <div class="col">
        <button
          class="btn btn-lg w-100 btn-dark"
          (click)="addMoreTaskTemplateRef.close()"
        >
          Cancel
        </button>
      </div>

      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          [disabled]="!selectedCheckList?.tasks?.[0]?.note"
          (click)="
            updateRunSheet(
              'checkList_tasks',
              {},
              {
                add_to_schedule: runSheetDetailData?.current_shift_only
                  ? 0
                  : runSheetDetailData?.future_schedule_exists &&
                      selectedCheckList?.check_list_schedule_uuid
                    ? 1
                    : 0,
              }
            );
            addMoreTaskTemplateRef.close()
          "
        >
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template
  #addMoreCheckListTemplate
  let-addMoreCheckListTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Add Tasks

      <span class="float-end" (click)="addMoreCheckListTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <gtapp-add-checklist
      [checkListData]="checkListData"
      [schedulerForm]="data?.schedulerInfo"
    ></gtapp-add-checklist>

    @if (runSheetDetailData?.future_schedule_exists) {
      <div
        class="col col-6 offset-6 my-3 gap-2 d-flex align-items-center justify-content-center fw-semibold"
      >
        <input
          class="form-check-input"
          type="checkbox"
          id="auto_send_reports"
          [checked]="runSheetDetailData?.current_shift_only"
          (change)="
            runSheetDetailData.current_shift_only =
              !runSheetDetailData?.current_shift_only
          "
        />
        <label class="form-check-label" for="auto_send_reports">
          Apply only to this shift</label
        >
      </div>
    }

    <div class="row row-cols-2 mt-4">
      <div class="col">
        <button
          class="btn btn-lg w-100 btn-dark"
          (click)="addMoreCheckListTemplateRef.close()"
        >
          Cancel
        </button>
      </div>

      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          [disabled]="
            !(
              checkListData[checkListData?.length - 1]?.tasks?.[0]?.note ||
              checkListData[checkListData?.length - 1]?.enable_reporting
            )
          "
          (click)="
            updateRunSheet(
              'checkList',
              {},
              {
                add_to_schedule: runSheetDetailData?.current_shift_only
                  ? 0
                  : runSheetDetailData?.future_schedule_exists
                    ? 1
                    : 0,
              }
            );
            addMoreCheckListTemplateRef.close()
          "
        >
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template
  #taskReminderTemplate
  let-taskReminderTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Set Task Reminder
      <span class="float-end" (click)="taskReminderTemplateRef.close(false)">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="row row-cols-2 mb-5">
      @if (data?.schedule?.showItems.startEndDateTime) {
        <div class="form-floating">
          <input
            id="startDay"
            class="form-control"
            type="datetime-local"
            placeholder="Pick Reminder Date & Time*"
            [(ngModel)]="data.schedule.start_datetime"
            [min]="data?.schedule?.minDateTime"
            [max]="data?.schedule?.maxDateTime"
            (change)="
              changeStartEndDateTime(
                $event,
                data?.schedule,
                'start_datetime',
                'startDateTime'
              )
            "
            [class.is-invalid]="data?.schedule?.invalid?.startDateTime"
          /><label for="startDay"> Reminder Date & Time*</label>
        </div>
      }
      @if (data?.schedule?.showItems.startEndTime) {
        <div class="form-floating col-6">
          <input
            type="time"
            class="form-control"
            id="startTime"
            placeholder="Reminder Time*"
            [(ngModel)]="data.schedule.start_time"
            (change)="
              changeStartEndDateTime(
                $event,
                data?.schedule,
                'start_time',
                'startTime'
              )
            "
            [class.is-invalid]="data?.schedule?.invalid?.startTime"
          />
          <label for="startTime" class="form-label">Reminder Time*</label>
        </div>
        <div class="small-font text-secondary">
          * Time will be rounded to nearest quarter
        </div>
      }
    </div>

    <div class="row row-cols-2">
      <div class="col">
        <button
          class="btn btn-light btn-lg w-100"
          (click)="taskReminderTemplateRef.close(false)"
        >
          Clear
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          [disabled]="
            data?.schedule?.invalid?.startTime ||
            data?.schedule?.invalid?.endTime ||
            data?.schedule?.invalid?.startDateTime ||
            data?.schedule?.invalid?.endDateTime
          "
          (click)="taskReminderTemplateRef.close(data)"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template
  #deleteCheckListTemplate
  let-deleteCheckListTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Delete Site
      <span class="float-end" (click)="deleteCheckListTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="alert">WARNING: This action cannot be undone.</div>

    @if (
      runSheetDetailData?.future_schedule_exists &&
      data?.check_list_schedule_uuid
    ) {
      <div
        class="col col-6 offset-6 my-3 gap-2 d-flex align-items-center justify-content-center fw-semibold mb-5"
      >
        <input
          class="form-check-input"
          type="checkbox"
          id="auto_send_reports"
          [checked]="data?.current_shift_only"
          (change)="data.current_shift_only = !data?.current_shift_only"
        />
        <label class="form-check-label" for="auto_send_reports">
          Apply only to this shift</label
        >
      </div>
    }

    <div class="row row-cols-2">
      <div class="col">
        <button
          class="btn btn-dark btn-lg w-100"
          (click)="deleteCheckListTemplateRef.close()"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-danger btn-lg w-100"
          (click)="
            deleteCheckListTemplateRef.close();
            updateRunSheet(
              'delete_checklist',
              {
                check_list_schedule_uuid: data?.check_list_schedule_uuid,
                check_list_uuid: data?.check_list_uuid,
              },
              {
                add_to_schedule: data?.current_shift_only
                  ? 0
                  : runSheetDetailData?.future_schedule_exists &&
                      data?.check_list_schedule_uuid
                    ? 1
                    : 0,
              }
            )
          "
        >
          Delete
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #promptTemplate let-promptTemplateRef="dialogRef" let-data>
  <div class="dialog-box card">
    <div class="card-header">
      <span class="float-end" (click)="promptTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <gtapp-mobile-form-input-data [mobileFormDataInput]="data">
    </gtapp-mobile-form-input-data>
  </div>
</ng-template>
